import { Routes } from '@angular/router';
import { authenticationGuard } from '@services';
import { environment } from '../environments/environment';
import { SvgIconsPageComponent } from '@ui-lib';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: 'telehealth',
    loadComponent: () =>
      import('./guest-meeting/guest-meeting.component').then(
        m => m.GuestMeetingComponent
      ),
  },
  {
    path: '',
    loadChildren: () => import('./main/main.routes').then(m => m.MAIN_ROUTES),
    canActivate: [authenticationGuard],
    canActivateChild: [authenticationGuard],
  },
  ...(!environment.production
    ? [{ path: 'icon-gallery', component: SvgIconsPageComponent }]
    : []),
];
